import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
const gtmTimelineYearNavigationClick = (gtmField) => {
    const { interactionType, type, title } = gtmField || {};
    const gtmPayload = {
        event: 'cta_click',
        click_text: title,
        interaction_type: interactionType,
        component_type: type,
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmTimelineYearNavigationClick;
